import type { ProductVariant } from '@/services/products'
import { normalizeTrustedHexInput } from './hexValidate'

/**
 * Premier `display_hex` valide sur une ligne variante dont l’axe `optionName` vaut `value`.
 */
export function trustedHexFromVariants(
  variants: ProductVariant[] | undefined,
  optionName: string,
  value: string,
): string | null {
  if (!variants?.length) return null
  const want = String(value).trim()
  if (!want) return null
  for (const row of variants) {
    const attrs = row.attributes || {}
    if (String(attrs[optionName] ?? '').trim() !== want) continue
    const raw = row.display_hex
    if (raw == null) continue
    const norm = normalizeTrustedHexInput(String(raw))
    if (norm) return norm
  }
  return null
}
